export default __webpack_public_path__ + "static/media/edge.e2009cb1.png";